const state = {
  data: [],
  message: '',
  authenticated: false
}

export default state



// WEBPACK FOOTER //
// ./src/store/modules/contributor/state.js